import httpApi from '@vue3/utils/http-api'
import { api } from '@vue3/configs'

export default {
  userLogin: (data) => {
    return httpApi.postDataViaApi({
      url: api.auth.login,
      body: data
    })
  },
  userLogout: () => {
    return httpApi.postDataViaApi({
      url: api.auth.logout
    })
  },
  userSignup: (data) => {
    return httpApi.postDataViaApi({
      url: api.auth.signup,
      body: data
    })
  },
  verifyEmailWithId: (query) => {
    return httpApi.getDataViaApi({
      url: api.auth.verifyEmailWithId,
      queryParams: query
    })
  },
  postResetPasswordInfo: (data) => {
    return httpApi.postDataViaApi({
      url: api.auth.resetPassword,
      body: data
    })
  },
  postForgotPasswordInfo: (data) => {
    return httpApi.postDataViaApi({
      url: api.auth.forgotPassword,
      body: data
    })
  },
  postVerifyPasswordWithId: (query) => {
    return httpApi.getDataViaApi({
      url: api.auth.verifyPasswordWithId,
      queryParams: query
    })
  },
  sendVerificationEmail: (data) => {
    return httpApi.postDataViaApi({
      url: api.auth.sendVerificationEmail,
      body: data
    })
  },
  sessionUpdate: () => {
    return httpApi.putDataViaApi({
      url: api.auth.sessionUpdate
    })
  },
  getUserDetails: () => {
    return httpApi.getDataViaApi({
      url: api.auth.userDetails
    })
  },
  switchCompany: (body) => {
    return httpApi.postDataViaApi({
      url: api.auth.switchCompany,
      body
    })
  },
  switchTheme: (queryParams) => {
    return httpApi.putDataViaApi({
      url: api.auth.switchTheme,
      queryParams
    })
  },
  updateNickName: (body) => {
    return httpApi.postDataViaApi({
      url: api.auth.updateNickName,
      body
    })
  }
}
